import React from 'react';
import Template from './jsx/Template';
import IndexPage from './jsx/IndexPage';
import PlatformPage from './jsx/account/PlatformPage';
import AccountPage from './jsx/account/AccountPage';
import HuobiPage from './jsx/coin/huobi/HuobiPage';
import HuobiDetailPage from './jsx/coin/huobi/HuobiDetailPage';
import OKExPage from './jsx/coin/okex/OKExPage';
import OKExDetailPage from './jsx/coin/okex/OKExDetailPage';
import QuantRobotPage from './jsx/coin/quant/QuantRobotPage';
import QuantRobotDetailPage from './jsx/coin/quant/QuantRobotDetailPage';
import MD5Page from './jsx/tool/MD5Page';
import MobileTemplate from './mobile/MobileTemplate';
import NoAuthPage from './mobile/NoAuthPage';
import QuantRobotDetailMobilePage from './mobile/QuantRobotDetailMobilePage';
import EatMobilePage from './mobile/EatMobilePage';

export const Index = props => {
    return (
        <Template history={props.history}>
            <IndexPage />
        </Template>
    );
}

export const Account = {
    platform: props => {
        return (
            <Template history={props.history}>
                <PlatformPage history={props.history} />
            </Template>
        );
    },
    account: props => {
        return (
            <Template history={props.history}>
                <AccountPage history={props.history} />
            </Template>
        );
    }
}

export const Coin = {
    huobi: props => {
        return (
            <Template history={props.history}>
                <HuobiPage history={props.history} />
            </Template>
        );
    },
    huobiDetail: props => {
        return (
            <Template history={props.history}>
                <HuobiDetailPage history={props.history} location={props.location} />
            </Template>
        );
    },
    okex: props => {
        return (
            <Template history={props.history}>
                <OKExPage history={props.history} />
            </Template>
        );
    },
    okexDetail: props => {
        return (
            <Template history={props.history}>
                <OKExDetailPage history={props.history} location={props.location} />
            </Template>
        );
    },
    quantRobot: props => {
        return (
            <Template history={props.history}>
                <QuantRobotPage history={props.history} />
            </Template>
        );
    },
    quantRobotDetail: props => {
        return (
            <Template history={props.history}>
                <QuantRobotDetailPage history={props.history} location={props.location} />
            </Template>
        );
    }
}

export const Tool = {
    md5: props => {
        return (
            <Template history={props.history}>
                <MD5Page history={props.history} />
            </Template>
        );
    }
}

export const Mobile = {
    noAuth: props => {
        return (
            <NoAuthPage history={props.history} location={props.location} />
        );
    },
    quantRobotDetail: props => {
        return (
            <MobileTemplate history={props.history}>
                <QuantRobotDetailMobilePage history={props.history} location={props.location} />
            </MobileTemplate>
        );
    },
    eat: props => {
        return (
            <MobileTemplate history={props.history}>
                <EatMobilePage history={props.history} location={props.location} />
            </MobileTemplate>
        );
    }
}




// WEBPACK FOOTER //
// ./src/page/Pages.jsx